import { render, staticRenderFns } from "./riskWarning.vue?vue&type=template&id=e137457c"
import script from "./riskWarning.vue?vue&type=script&lang=js"
export * from "./riskWarning.vue?vue&type=script&lang=js"
import style0 from "./riskWarning.vue?vue&type=style&index=0&id=e137457c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports